<template>
    <div class="platform-card" :class="cardClass">
        <div class="platform-header">
            <div class="platform-logo" :class="platformLogoClass">
                <svg-icon v-if="type === 'appleMusic'" icon-class="new-appleMusic"></svg-icon>
                <svg-icon v-else-if="type === 'Spotify'" icon-class="new-spotify"></svg-icon>
                <svg-icon v-else-if="type === 'qqMusic'" icon-class="new-qq"></svg-icon>
                <svg-icon v-else-if="type === 'netease'" icon-class="new-wyy"></svg-icon>
            </div>
            <div class="platform-info">
                <div class="platform-name">{{ platformName }}</div>
                <div class="platform-subtitle">艺人主页</div>
            </div>
        </div>
        <div class="platform-divider"></div>
        <div class="platform-content">
            <div class="status-row">
                <span class="status-dot" :class="statusClass"></span>
                <span class="status-text" :class="statusClass">{{ statusText }}</span>
            </div>
            <template v-if="showBoundButtons">
                <div class="artist-info">
                    <div class="cover-wrapper">
                        <el-image v-if="coverUrl" class="artist-cover" :src="coverUrl" fit="cover" :preview-src-list="[coverUrl]" :z-index="4000">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                                <span class="no-image-text">暂无图片</span>
                            </div>
                        </el-image>
                        <div v-else class="no-image-slot">
                            <i class="el-icon-picture-outline"></i>
                            <span class="no-image-text">暂无图片</span>
                        </div>
                    </div>
                    <div class="artist-detail">
                        <div class="artist-name-value">{{ artistName || '-' }}</div>
                        <div class="artist-id-label">ID：{{ artistId || '-' }}</div>
                    </div>
                </div>
                <div class="empty-placeholder"></div>
                <div class="action-btns">
                    <el-button size="small" @click.stop="handleStore" :disabled="!storeUrl" class="btn-default">查看主页</el-button>
                    <el-button size="small" @click.stop="handleEdit" :disabled="isView" class="btn-default">修改</el-button>
                    <el-button size="small" type="danger" plain @click.stop="handleUnRelease" :disabled="isView" class="btn-danger">
                        解除关联
                    </el-button>
                </div>
            </template>
            <template v-else>
                <div class="unrelated-tip">
                    可搜索艺人名称或ID，选择正确结果进行关联
                </div>
                <div class="empty-placeholder"></div>
                <div class="action-btns action-btns-full">
                    <template v-if="type === 'qqMusic' || type === 'netease'">
                        <el-button size="small" class="link-btn" @click.stop="handleInputId" :disabled="isView">去关联</el-button>
                    </template>
                    <template v-else>
                        <el-button size="small" class="link-btn" @click.stop="handleRelease" :disabled="isView">去关联</el-button>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        coverUrl: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'appleMusic'
        },
        hasReleaseId: {
            type: Boolean,
            default: false
        },
        isView: {
            type: Boolean,
            default: false
        },
        storeUrl: {
            type: String,
            default: ''
        },
        platformStatus: {
            type: Number,
            default: null
        },
        artistName: {
            type: String,
            default: ''
        },
        artistId: {
            type: String,
            default: ''
        }
    },
    computed: {
        platformName() {
            const nameMap = {
                appleMusic: 'Apple Music',
                Spotify: 'Spotify',
                qqMusic: 'QQ音乐',
                netease: '网易云音乐'
            };
            return nameMap[this.type] || '';
        },
        platformLogoClass() {
            const classMap = {
                appleMusic: 'apple-logo',
                Spotify: 'spotify-logo',
                qqMusic: 'qq-logo',
                netease: 'netease-logo'
            };
            return classMap[this.type] || '';
        },
        currentStatus() {
            return this.platformStatus;
        },
        isStatusSpecial() {
            return this.currentStatus === 2;
        },
        isStatusFullyBound() {
            // status=1 是完全已关联（绿色已关联）
            return this.currentStatus === 1;
        },
        isRelated() {
            // Apple Music：status=1（已关联）和status=2（知名/认证艺人）都显示已关联按钮和艺人信息
            if (this.type === 'appleMusic') {
                return this.currentStatus === 1 || this.currentStatus === 2;
            }
            // Spotify：只有status=1（已关联）显示已关联按钮，status=2（新建主页）显示去关联
            if (this.type === 'Spotify') {
                return this.currentStatus === 1;
            }
            // QQ音乐、网易云：status=1才是已关联
            return this.currentStatus === 1;
        },
        statusText() {
            if (this.isStatusFullyBound) return '已关联';
            if (this.isStatusSpecial) {
                if (this.type === 'appleMusic') return '知名/认证艺人';
                return '新建主页';
            }
            return '未关联';
        },
        statusClass() {
            if (this.isStatusFullyBound) return 'status-related';
            if (this.isStatusSpecial) return 'status-special';
            return 'status-unrelated';
        },
        cardClass() {
            if (this.isRelated) return 'card-related';
            if (this.isStatusSpecial) return 'card-special';
            return 'card-unrelated';
        },
        showBoundButtons() {
            return this.isRelated;
        }
    },
    data() {
        return {};
    },
    methods: {
        handleRelease() {
            this.$emit('handleRelease');
        },
        handleUnRelease() {
            this.$emit('handleUnRelease');
        },
        handleStore() {
            this.$emit('handleStore');
        },
        handleInputId() {
            this.$emit('handleInputId');
        },
        handleEdit() {
            this.$emit('handleEdit');
        }
    }
};
</script>

<style lang="scss" scoped>
.platform-card {
    border: 1px solid #e4e7ed;
    border-radius: 12px;
    padding: 14px;
    background: #fff;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 240px;
    &:hover {
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
    }
    .platform-header {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        .platform-logo {
            width: 40px;
            height: 40px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            line-height: 0;
            vertical-align: middle;

            &.spotify-logo {
                background: #000000;
                border-radius: 9px;

                ::v-deep {
                    .svg-icon {
                        width: 34px !important;
                        height: 34px !important;
                        font-size: 34px !important;
                    }

                    svg {
                        width: 34px !important;
                        height: 34px !important;
                    }
                }
            }

            &.qq-logo {
                background: #ffffff;
                border-radius: 9px;
                box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04);

                ::v-deep {
                    .svg-icon {
                        width: 36px !important;
                        height: 36px !important;
                        font-size: 36px !important;
                    }

                    svg {
                        width: 36px !important;
                        height: 36px !important;
                    }
                }
            }

            ::v-deep {
                .svg-icon {
                    width: 40px !important;
                    height: 40px !important;
                    font-size: 40px !important;
                    display: block;
                    line-height: 1;
                }

                svg {
                    display: block;
                    width: 40px !important;
                    height: 40px !important;
                }
            }
        }
        .platform-info {
            margin-left: 10px;
            min-width: 0;
            .platform-name {
                font-size: 15px;
                font-weight: 600;
                color: #303133;
                line-height: 1.3;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .platform-subtitle {
                font-size: 13px;
                color: #909399;
                margin-top: 2px;
            }
        }
    }
    .platform-divider {
        height: 1px;
        background: #f0f2f5;
        margin: 12px 0;
        flex-shrink: 0;
    }
    .platform-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0;
        .status-row {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            flex-shrink: 0;
            .status-dot {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                margin-right: 8px;
                flex-shrink: 0;
                &.status-related {
                    background: #00b42a;
                }
                &.status-special {
                    background: #ff7d00;
                }
                &.status-unrelated {
                    border: 1px solid #c0c4cc;
                }
            }
            .status-text {
                font-size: 15px;
                font-weight: 600;
                color: #303133;
            }
            .status-special {
                color: #ff7d00 !important;
            }
            .status-unrelated {
                color: #c0c4cc !important;
            }
        }
        .artist-info {
            display: flex;
            margin-bottom: 16px;
            flex-shrink: 0;
            .cover-wrapper {
                width: 64px;
                height: 64px;
                flex-shrink: 0;
                border-radius: 8px;
                overflow: hidden;
            }
            .artist-cover {
                width: 64px;
                height: 64px;
                border-radius: 8px;
                cursor: pointer;
                ::v-deep .image-slot {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #f5f7fa;
                    color: #c0c4cc;
                    font-size: 24px;
                    border-radius: 8px;
                }
            }
            .no-image-slot {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                background: #f5f7fa;
                color: #c0c4cc;
                border-radius: 8px;
                i {
                    font-size: 24px;
                    margin-bottom: 4px;
                }
                .no-image-text {
                    font-size: 12px;
                }
            }
            .artist-detail {
                margin-left: 12px;
                flex: 1;
                min-width: 0;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .artist-name-value {
                    font-size: 15px;
                    font-weight: 600;
                    color: #303133;
                    margin-bottom: 6px;
                    word-break: break-all;
                    line-height: 1.3;
                }
                .artist-id-label {
                    font-size: 13px;
                    color: #606266;
                    word-break: break-all;
                    line-height: 1.3;
                }
            }
        }
        .unrelated-tip {
            font-size: 14px;
            color: #606266;
            line-height: 1.5;
            flex-shrink: 0;
        }
        .empty-placeholder {
            flex: 1;
            min-height: 16px;
        }
        .action-btns {
            display: flex;
            gap: 6px;
            flex-wrap: nowrap;
            margin-top: auto;
            flex-shrink: 0;
            padding-top: 12px;
            .el-button {
                flex: 1;
                min-width: 0;
                padding: 7px 2px;
                font-size: 13px;
                border-radius: 6px;
                height: 32px;
                line-height: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                &.btn-default {
                    background: #fff;
                    border: 1px solid #dcdfe6;
                    color: #606266;
                    &:hover,
                    &:focus {
                        background: #ecf5ff;
                        border-color: #c6e2ff;
                        color: #409eff;
                    }
                }
                &.btn-danger {
                    color: #f56c6c;
                    border-color: #fbc4c4;
                    background: #fef0f0 !important;
                    font-weight: 500;
                    &:hover,
                    &:focus {
                        color: #f56c6c !important;
                        border-color: #f56c6c !important;
                        background: #fde2e2 !important;
                    }
                }
                &.link-btn {
                    background-color: #fff;
                    border: 1px solid #722ed1;
                    color: #722ed1;
                    font-weight: 500;
                    border-radius: 6px;
                    padding: 9px 4px;
                    height: 36px;
                    font-size: 14px;
                    &:hover,
                    &:focus {
                        background-color: #f9f0ff;
                        border-color: #722ed1;
                        color: #722ed1;
                    }
                }
            }
        }
        .action-btns-full {
            .el-button {
                padding: 9px 4px;
                font-size: 14px;
                height: 36px;
            }
        }
    }
}
.card-related {
    border-color: #e4e7ed;
}
.card-unrelated {
    border-color: #e4e7ed;
}
</style>
